import { render, staticRenderFns } from "./SistemaView.vue?vue&type=template&id=3b4d27e0&scoped=true&"
import script from "./SistemaView.vue?vue&type=script&lang=js&"
export * from "./SistemaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d27e0",
  null
  
)

export default component.exports